import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, fromEvent } from 'rxjs';
import { CecBreakpoint } from '../types/cec-breakpoint.type';
import { CEC_BREAKPOINTS } from '../constants/cec-breakpoints.constant';

@Injectable({
  providedIn: 'root',
})
export class CecBreakpointService {
  private currentBreakpointSubject: BehaviorSubject<CecBreakpoint> =
    new BehaviorSubject<CecBreakpoint>('');
  /** Get current breakpoint */
  public currentBreakpoint$ = this.currentBreakpointSubject.asObservable();

  constructor() {
    fromEvent(window, 'resize')
      .pipe(
        // Only emit when the breakpoint changes
        distinctUntilChanged(),
      )
      .subscribe((event) => {
        const width = (event.target as Window).innerWidth;
        this.updateBreakpoint(width);
      });

    // Get screen width after load
    this.updateBreakpoint(window.innerWidth);
  }

  /**
   * Change breakpoint type based on changed screen width
   * @param windowWidth Screen width
   */
  private updateBreakpoint(windowWidth: number): void {
    let newBreakpoint = '';

    if (windowWidth >= CEC_BREAKPOINTS.xxl) {
      newBreakpoint = 'xxl';
    } else if (windowWidth >= CEC_BREAKPOINTS.xl) {
      newBreakpoint = 'xl';
    } else if (windowWidth >= CEC_BREAKPOINTS.lg) {
      newBreakpoint = 'lg';
    } else if (windowWidth >= CEC_BREAKPOINTS.md) {
      newBreakpoint = 'md';
    } else if (windowWidth >= CEC_BREAKPOINTS.sm) {
      newBreakpoint = 'sm';
    } else {
      newBreakpoint = 'xs';
    }

    if (newBreakpoint !== this.currentBreakpointSubject.value) {
      this.currentBreakpointSubject.next(newBreakpoint);
    }
  }
}
